'use client' // Error boundaries must be Client Components

import * as Sentry from '@sentry/nextjs'
import React from 'react'

import { ErrInternalServerError } from '@/_pages/error-internal-server-error'

export default function ErrorPage({ error }: { error: Error & { digest?: string } }) {
    React.useEffect(() => {
        Sentry.captureException(error)
    }, [error])

    return <ErrInternalServerError message={error.message} digest={error.digest} />
}
